import { type ReactNode, type ComponentPropsWithoutRef } from 'react';
import { createPath, type To } from 'react-router';
import { useNavigate } from '../routing/navigate';

export interface LinkProps extends Omit<ComponentPropsWithoutRef<'a'>, 'href'> {
  replace?: boolean;
  to: To;
}

export function Link({ children, onClick, replace, to, ...props }: LinkProps): ReactNode {
  const navigate = useNavigate();
  const url = typeof to === 'string' ? to : createPath(to);
  const isExternal = /^https?:\/\//.test(url) || url.startsWith('//');

  const onClickHandler = (event: React.MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event);

    // Only prevent default and use client-side routing for internal links.
    // For external links, let the browser handle navigation naturally.
    if (!isExternal) {
      event.preventDefault();
      navigate(to, { replace });
    }
  };

  return (
    <a href={url} onClick={onClickHandler} {...props}>
      {children}
    </a>
  );
}
